/* eslint-disable no-unreachable */
import { asyncThunkCreator, buildCreateSlice } from "@reduxjs/toolkit";

export const getAPIHeaders = ({ queryParams = null, extraHeaders = {} }) => {
  const activeSession = sessionStorage.getItem("activeSession")
    ? JSON.parse(sessionStorage.getItem("activeSession"))
    : null;

  return {
    headers: {
      Authorization: activeSession?.session_token
        ? `Bearer ${activeSession?.session_token}`
        : null,
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*/*",
      Accept: "application/json",
      "x-api-key": `${process.env.REACT_APP_API_KEY}`,
      ...extraHeaders,
    },
    params: queryParams,
    validateStatus: (status) => {
      return status < 500;
    },
  };
};

export const createSliceWithThunks = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const generateRandomString = (length = 8) => {
  let result = "";
  let characters =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const base64FileDetails = (base64String) => {
  let _strings = base64String.split(",");
  let file = {};
  switch (
    _strings[0] //check files's extension
  ) {
    case "data:application/pdf;base64":
      file = {
        ...file,
        type: "Document",
        extension: "pdf",
      };
      break;
    case "data:image/jpeg;base64":
      file = {
        ...file,
        type: "Image",
        extension: "jpeg",
      };
      break;
    case "data:image/png;base64":
      file = {
        ...file,
        type: "Image",
        extension: "png",
      };
      break;
    default:
      //should write cases for more images types
      file = {
        ...file,
        type: "Image",
        extension: "jpg",
      };
      break;
  }

  return file;
};

export const getBase64 = async (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export const hasAccess = (resource) => {
  if (sessionStorage.getItem("activeSession")) {
    const session = JSON.parse(sessionStorage.getItem("activeSession"));
    let response = false;

    session?.resources?.forEach((item) => {
      if (resource === item) {
        response = true;
      }
    });

    return response;
  } else {
    return false;
  }
};

export const dateFormat = "DD-MMM-YYYY";
export const dateFormatWithTime = "DD-MMM-YYYY HH:mm:ss";
export const oracleDateFormat = "DD-MMM-YYYY hh:mm:ss A";
